import {Box, Text, VStack} from "@chakra-ui/react";
import {CustomCloserButton, EmptyState, L5Button, ListContainer} from "./CustomButton";
import CustomTimePicker from "./CustomTimePicker";
import SelectTimeBox from "./SelectTimeBox";
import SuccessModal, {ConfirmationButton, ConfirmationModal, CustoMenu, Description, ModalForm} from "./CustomModal";
import SearchIcon from "./SearchIcon";
import WheelDateTimePicker from "./WheelDateTimePicker";
import SearchBar from "./SearchBar";
import HeaderComponent, {MultipleTabs, SystemTab} from "./HeaderComponent";
import {CustomSelect, Shimmer} from "./CustomSelect";
import {FormInput} from "./CustomInput";
import {CheckboxCard, ChoiceRadio, RadioCard} from "./SelectableCard";
import {StructureDrawer} from "./StructureDrawer";
import GenericPaginatedTable from "./GenericTable";
import {InfoFetchingError, NoUser, UserCard, UserCreationLink} from "./UserSelector";
import {InfoTooltip, Topic, TopicItem, TopicIndicator} from "./Topic";
import {InfoBoxProps} from "../../models";
import {useVerification} from "../../context";

export function IntentIndicator(props: {for: "creation" | "action"}) {
    const {canAct, canCreate} = useVerification();
    let text: string = "";
    if (props.for === "creation" && !canCreate) {
        text = "you currently have a pending request creation. Please verify " +
        "or complete it before starting a new one.";
    }
    if (props.for === "action" && !canAct) {
        text = "you already have a pending action intent for this request. " +
        "Please confirm or complete it before proceeding with another action.";
    }
    if (!text) {
        return <></>;
    }
    return <Text
        fontSize={"md"}
        color="gray.500"
        position="sticky"
        w="full"
        px=".5rem"
        textAlign="center"
        style={{textWrap: "pretty" }}
        top="-4px"
        zIndex="overlay"
        bg="white"
    >
        {text}
    </Text>;
}

function Icon(props: {type: "eye" | "trash" | "upload" | "download"}) {
    return <svg width="24" height="24" aria-hidden="true">
        <use xlinkHref={`#${props.type}`}/>
    </svg>;
};

export function InfoBox(props: InfoBoxProps) {
    return <Box className="stack info-box" alignSelf="stretch">
        <TopicItem
            s="24"
            textTransform={props.noCase ? undefined : "capitalize"}
            value={props.title}
            icon={props.icon}
            color="primary.500"
            as="p"
        />
        {props.items.length > 0 && <VStack
            alignItems="stretch"
            bgColor="#F5F7F9"
            borderRadius="8px"
            gap=".5rem"
            p=".5rem .75rem"
            color="dark.500"
            w="100%"
        >
            {props.items.map((v, i) => <Topic key={i} {...v}/>)}
        </VStack>}
        {props.node}
    </Box>
}

export {
    CheckboxCard,
    ChoiceRadio,
    ConfirmationModal,
    ConfirmationButton,
    CustoMenu,
    CustomCloserButton,
    CustomSelect,
    CustomTimePicker,
    Description,
    EmptyState,
    FormInput,
    Icon,
    InfoFetchingError,
    InfoTooltip,
    ListContainer,
    L5Button,
    ModalForm,
    MultipleTabs,
    NoUser,
    GenericPaginatedTable,
    HeaderComponent,
    RadioCard,
    SearchBar,
    SearchIcon,
    SelectTimeBox,
    SuccessModal,
    Shimmer,
    StructureDrawer,
    SystemTab,
    Topic,
    TopicIndicator,
    TopicItem,
    UserCard,
    UserCreationLink,
    WheelDateTimePicker
};
